import styled from "@emotion/styled";
import { FormLabel } from "@otrium/atoms";
import { ReactNode } from "react";

const RadioButton = styled.input<{ disabled?: boolean }>`
  position: relative;
  appearance: none;
  min-width: 18px;
  width: 18px;
  height: 18px;
  background-clip: content-box;
  border: 1px solid #ccc;
  border-radius: 50%;
  padding: 4px;
  transition: all 200ms;
  margin-right: ${({ theme }) => theme.space[2]}px;
  box-sizing: border-box;
  ${({ disabled }) => !disabled && "cursor: pointer;"}

  &:focus {
    border-color: ${({ theme }) => theme.colors.semantic.blue};
  }

  &:checked {
    border-color: ${({ theme }) => theme.colors.tone.black};
    background-color: ${({ theme }) => theme.colors.tone.black};
  }
  &:disabled {
    border-color: ${({ theme }) => theme.colors.tone.silver};
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background-color: ${({ theme }) => theme.colors.tone.marble};
      border-radius: 50%;
    }
  }
  &:checked:disabled {
    border-color: ${({ theme }) => theme.colors.tone.silver};
    &::after {
      content: "";
      position: absolute;
      width: 50%;
      height: 50%;
      left: 50%;
      top: 50%;
      background-color: ${({ theme }) => theme.colors.tone.anthraciteLight};
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

const RadioLabel = styled(FormLabel)<{
  disabled?: boolean;
  children: ReactNode[];
}>`
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.tone.black};
  display: flex;
  ${({ disabled }) => !disabled && "cursor: pointer;"}
  &:hover > input {
    border-color: ${({ theme }) => theme.colors.tone.black};
  }

  &:hover > input:disabled {
    border-color: ${({ theme }) => theme.colors.tone.silver};
  }
`;

export { RadioLabel, RadioButton };
